export default {
  title: {
    en: 'Whoops! That’s a prepaid card.',
  },
  text: {
    en: `
      Our system accepts prepaid cards but have some restrictions. Not all
      prepaid cards support subscription charges. If you choose to enter a
      credit card we will issue an additional $5 discount for your
      inconvenience. You can still proceed with your prepaid card.
    `,
  },
  buttonTitle: {
    en: 'Re-enter payment info',
  },
  proceedButton: {
    en: 'Proceed with a prepaid card',
  },
}
